<template>
  <div>
    <site-header>
      <h1>About me</h1>
    </site-header>

    <main :class="$style.about" class="wrap"
      v-if="this.page.content"
      v-html="this.page.content.rendered"
      ref="pageContent">
    </main>

    <loader v-if="this.loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import each from 'lodash/each';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'about',

    components: {
      SiteHeader,
      Loader,
    },

    head: {
      title() {
        return {
          inner: 'About',
        };
      },
    },

    data() {
      return {
        loading: true,
        page: [],
      };
    },

    mounted() {
      axios.get('/api/pages/about').then((response) => {
        if (response.data) {
          this.loading = false;
          this.page = response.data[0];
        }
      });
    },

    updated() {
      const links = this.$refs.pageContent.querySelectorAll('a');

      each(links, (link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          this.$router.push(e.target.getAttribute('href'));
        });
      });
    },
  };
</script>

<style module lang="postcss">
  .about {
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5rem;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }

    & h2 {
      margin: 1.7rem 0 0.8rem;
      font-size: 1.3rem;
    }

    & p {
      display: block;
      font-size: 1.1rem;
      margin-bottom: 1.7rem;
      line-height: 1.5;

      @media (width >= 75em) {
        padding-right: 12em;
      }
    }

    & img {
      width: 100%;
      margin: 0 0 1.7rem;
      padding: 0;
      box-shadow: -1rem -1rem 0 #f8f8f8;

      @media (width >= 33em) {
        margin: 1.5rem 0 3rem 3rem;
        width: 16rem;
        float: right;
      }

      @media (width >= 75em) {
        /*margin-top: 0;*/
      }
    }
  }

  .contactForm {
    & label,
    & span {
      display: block;
      width: 100%;
      max-width: 30rem;
    }

    & label {
      margin-bottom: 2rem;
      cursor: pointer;
    }

    & span {
      margin-bottom: 0.75rem;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.2;
      letter-spacing: 0.05rem;
      text-indent: 0.05rem;
      text-transform: uppercase;
      color: #444;
    }

    & input {
      font-size: 1.4rem;
    }

    & input,
    & textarea {
      border: 0;
      padding: 1rem;
      width: 100%;
      font-family: 'franklin-gothic-urw', sans-serif;
      background-color: #f8f8f8;

      &:focus {
        box-shadow: 0 3px 0 0 #000;
        outline: 0;
        background-color: #eee;
      }
    }

    & button {
      -webkit-appearance: none;
      padding: 0.5rem 1rem;
      font-family: 'franklin-gothic-urw', sans-serif;
      background-color: #000;
      color: #fff;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// About.vue?39b5e0fc